<template>
	<div class="my-account">
		<div class="wrapper">
			<div class="header">
				<div class="headerCon">
					<div class="account acea-row row-top row-between">
						<div class="assets">
							<div>我的金券</div>
							<div class="money">{{ new_jinquan || 0 }}</div>
						</div>
						<div>
							<router-link :to="'/user/user_cash'" class="recharge font-color-green">提现</router-link>
							<router-link :to="'/user/Recharge'" class="recharge font-color-red">转会员</router-link>
						</div>
						
					</div>
					<div class="cumulative acea-row row-top">
						
						<div class="item">
							<div>1金券=1元</div>
							<!-- <div class="money">{{ recharge }}</div> -->
						</div>
						<div class="item">
							<!-- <div>累计消费(元)</div>
							<div class="money">{{ orderStatusSum }}</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="sign-record" ref="container">
				<div class="list">
					<div class="item" v-for="(item, index) in list" :key="index">
						<!-- <div class="data">{{ item.time }}</div> -->
						<div class="listn" v-for="(val, key) in item.list" :key="key">
							<div class="itemn acea-row row-between-wrapper">
								<div>
									<div class="name line1">{{ val.title }}</div>
									<div>{{ val.add_time }}</div>
								</div>
								<div class="num" :class="val.pm == 0 ? 'font-color-red' : ''">
									{{ val.pm == 0 ? "-" : "+" }}{{ val.number }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="noCart" v-if="list.length === 0 && where.page > 1">
				<div class="pictrue"><img src="@assets/images/noList.png" /></div>
			</div>
			
		</div>
		<Loading :loaded="loaded" :loading="loading"></Loading>
	</div>
</template>
<script>
	import Recommend from "@components/Recommend";
	import {
		getActivityStatus,
		getBalance,
		getCommissionInfo
	} from "../../api/user";
	const NAME = "UserAccount";
	import Loading from "@components/Loading";
	export default {
		name: NAME,
		components: {
			Recommend,
			Loading
		},
		props: {},
		data: function() {
			return {
				new_jinquan: 0,
				orderStatusSum: 0,
				recharge: 0,
				activity: {
					is_bargin: false,
					is_pink: false,
					is_seckill: false
				},
				types: 5,
				where: {
					page: 1,
					limit: 10
				},
				list: [],
				loaded: false,
				loading: false
			};
		},
		watch: {
			$route(n) {
				if (n.name === NAME) this.getIndex();
			}
		},
		mounted: function() {
			this.getIndex();
			this.getActivity();
			this.getIndex1()
			this.$scroll(this.$refs.container, () => {
				!this.loading && this.getIndex1();
			});
		},
		
		methods: {
			getIndex1: function() {
				let that = this;
				if (that.loaded == true || that.loading == true) return;
				that.loading = true;
				getCommissionInfo(that.where, that.types).then(
					res => {
						that.loading = false;
						that.loaded = res.data.length < that.where.limit;
						that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
						that.where.page = that.where.page + 1;
						that.list.push.apply(that.list, res.data);
					},
					err => {
						that.$dialog.message(err.msg);
					}
				);
			},
			getIndex: function() {
				let that = this;
				getBalance().then(
					res => {
						that.new_jinquan = res.data.new_jinquan;
						that.orderStatusSum = res.data.orderStatusSum;
						that.recharge = res.data.recharge;
					},
					err => {
						that.$dialog.message(err.msg);
					}
				);
			},
			getActivity: function() {
				let that = this;
				getActivityStatus().then(
					res => {
						that.activity.is_bargin = res.data.is_bargin;
						that.activity.is_pink = res.data.is_pink;
						that.activity.is_seckill = res.data.is_seckill;
					},
					error => {
						that.$dialog.message(error.msg);
					}
				);
			}
		}
	};
</script>


<style scoped>
	.noCart {
		margin-top: 0.17rem;
		padding-top: 0.1rem;
	}

	.noCart .pictrue {
		width: 4rem;
		height: 3rem;
		margin: 0.7rem auto 0.5rem auto;
	}

	.noCart .pictrue img {
		width: 100%;
		height: 100%;
	}
</style>
